/* eslint-disable dot-notation */

export function registerSoundGenerators(gen) {
  gen.forBlock['sound_play'] = (block) => {
    const sound = block.getFieldValue('SOUND') || 'ting'
    return `playSound('${sound}');\n`
  }

  gen.forBlock['sound_loop'] = (block) => {
    const audio = block.getFieldValue('AUDIO') || 'happy'
    return `playMusic('${audio}');\n`
  }

  gen.forBlock['sound_stop'] = () => `stopAudio();\n`
}
